import React, { useState, useEffect } from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import Select from 'react-select';
import moment from 'moment';
import * as api from '~/Services/Service';
import { menuPortalProps, menuPortalStyles } from './selectMenuPortal';

var formatarInicio = function (valor) {
  if (!valor) return '';
  var m = moment(valor);
  return m.isValid() ? m.format('DD/MM/YYYY HH:mm:ss') : valor;
};

var TabGeral = function (_ref) {
  var parametros = _ref.parametros;
  var onChange = _ref.onChange;

  var [departamentos, setDepartamentos] = useState([]);

  useEffect(function () {
    api.listarDepartamentosLookup().then(function (res) {
      setDepartamentos((res || []).map(function (d) { return { value: d.codigo, label: d.descricao }; }));
    }).catch(function () {});
  }, []);

  var p = parametros || {};

  var handleChange = function (campo, valor) {
    onChange(Object.assign({}, p, { [campo]: valor }));
  };

  var selectDepto = departamentos.find(function (d) { return d.value === p.departamento_comissao; }) || null;

  return (
    <div>
      <Row>
        <Col md={2}>
          <Form.Group>
            <Form.Label>Código</Form.Label>
            <Form.Control type="text" readOnly value={p.codigo != null ? p.codigo : ''} />
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group>
            <Form.Label>Código (Param)</Form.Label>
            <Form.Control type="text" readOnly value={p.cod_param || ''} />
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group>
            <Form.Label>Início</Form.Label>
            <Form.Control type="text" readOnly value={formatarInicio(p.inicio)} />
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col md={3}>
          <Form.Group>
            <Form.Label>C.C. Conta Dif.</Form.Label>
            <Form.Control
              type="number"
              value={p.cc_conta_dif || ''}
              onChange={function (e) { handleChange('cc_conta_dif', e.target.value); }}
            />
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group>
            <Form.Label>Conta Dif. 3 Decimais</Form.Label>
            <Form.Control
              type="number"
              value={p.contadif || ''}
              onChange={function (e) { handleChange('contadif', e.target.value); }}
            />
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group>
            <Form.Label>Conta Zer. Refinan.</Form.Label>
            <Form.Control
              type="number"
              value={p.zera_refinan || ''}
              onChange={function (e) { handleChange('zera_refinan', e.target.value); }}
            />
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group>
            <Form.Label>C.C. (Refinan)</Form.Label>
            <Form.Control
              type="number"
              value={p.cc_zera_refinan || ''}
              onChange={function (e) { handleChange('cc_zera_refinan', e.target.value); }}
            />
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col md={2}>
          <Form.Group>
            <Form.Label>Contábil</Form.Label>
            <Form.Control
              as="select"
              value={p.contabil || 'N'}
              onChange={function (e) { handleChange('contabil', e.target.value); }}
            >
              <option value="S">Sim</option>
              <option value="N">Não</option>
            </Form.Control>
          </Form.Group>
        </Col>
        <Col md={2}>
          <Form.Group>
            <Form.Label>Controla Despesas</Form.Label>
            <Form.Control
              as="select"
              value={p.controla_despesas || 'N'}
              onChange={function (e) { handleChange('controla_despesas', e.target.value); }}
            >
              <option value="S">Sim</option>
              <option value="N">Não</option>
            </Form.Control>
          </Form.Group>
        </Col>
        <Col md={2}>
          <Form.Group>
            <Form.Label>Controla Centro Lucro</Form.Label>
            <Form.Control
              as="select"
              value={p.controla_centro_lucro || 'N'}
              onChange={function (e) { handleChange('controla_centro_lucro', e.target.value); }}
            >
              <option value="S">Sim</option>
              <option value="N">Não</option>
            </Form.Control>
          </Form.Group>
        </Col>
        <Col md={2} className="d-flex align-items-center pt-3">
          <Form.Check
            type="checkbox"
            label="Conta PJ Caso Jurídico"
            checked={p.conta_pj_caso_jur === 'S'}
            onChange={function (e) { handleChange('conta_pj_caso_jur', e.target.checked ? 'S' : 'N'); }}
          />
        </Col>
        <Col md={2} className="d-flex align-items-center pt-3">
          <Form.Check
            type="checkbox"
            label="Trava Lançamento Despesa"
            checked={p.proibe_despesa === 'S'}
            onChange={function (e) { handleChange('proibe_despesa', e.target.checked ? 'S' : 'N'); }}
          />
        </Col>
      </Row>
      <Row>
        <Col md={4}>
          <Form.Group>
            <Form.Label>Departamento de Comissão</Form.Label>
            <Select
              value={selectDepto}
              options={departamentos}
              onChange={function (opt) { handleChange('departamento_comissao', opt ? opt.value : null); }}
              placeholder="Selecione..."
              isClearable
              {...menuPortalProps}
              styles={menuPortalStyles}
            />
          </Form.Group>
        </Col>
        <Col md={2}>
          <Form.Group>
            <Form.Label>Gestor Autoriza Orçamento</Form.Label>
            <Form.Control
              as="select"
              value={p.aut_gestor_pj || 'N'}
              onChange={function (e) { handleChange('aut_gestor_pj', e.target.value); }}
            >
              <option value="S">Sim</option>
              <option value="N">Não</option>
            </Form.Control>
          </Form.Group>
        </Col>
        <Col md={2}>
          <Form.Group>
            <Form.Label>Aprovação somente na Requisição</Form.Label>
            <Form.Control
              as="select"
              value={p.requisicao_liberada || 'N'}
              onChange={function (e) { handleChange('requisicao_liberada', e.target.value); }}
            >
              <option value="S">Sim</option>
              <option value="N">Não</option>
            </Form.Control>
          </Form.Group>
        </Col>
        <Col md={2}>
          <Form.Group>
            <Form.Label>Valor Máx. Aprovação Gestor</Form.Label>
            <Form.Control
              type="number"
              step="0.01"
              value={p.vl_maximo_gestor || ''}
              onChange={function (e) { handleChange('vl_maximo_gestor', e.target.value); }}
            />
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col md={2}>
          <Form.Group>
            <Form.Label>Obs. obrigatória na solicitação</Form.Label>
            <Form.Control
              type="text"
              maxLength={1}
              value={p.trava_obs_sol || ''}
              onChange={function (e) { handleChange('trava_obs_sol', e.target.value); }}
            />
          </Form.Group>
        </Col>
        <Col md={2}>
          <Form.Group>
            <Form.Label>Controla Despesa Matricial</Form.Label>
            <Form.Control
              as="select"
              value={p.matricial || 'N'}
              onChange={function (e) { handleChange('matricial', e.target.value); }}
            >
              <option value="S">Sim</option>
              <option value="N">Não</option>
            </Form.Control>
          </Form.Group>
        </Col>
        <Col md={2}>
          <Form.Group>
            <Form.Label>% até variação</Form.Label>
            <Form.Control
              type="number"
              step="0.01"
              value={p.perc_ate || ''}
              onChange={function (e) { handleChange('perc_ate', e.target.value); }}
            />
          </Form.Group>
        </Col>
        <Col md={2}>
          <Form.Group>
            <Form.Label>Valor de variação</Form.Label>
            <Form.Control
              type="number"
              step="0.01"
              value={p.vl_varia || ''}
              onChange={function (e) { handleChange('vl_varia', e.target.value); }}
            />
          </Form.Group>
        </Col>
        <Col md={2}>
          <Form.Group>
            <Form.Label>% após variação</Form.Label>
            <Form.Control
              type="number"
              step="0.01"
              value={p.perc_acima || ''}
              onChange={function (e) { handleChange('perc_acima', e.target.value); }}
            />
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col md={2}>
          <Form.Group>
            <Form.Label>Trava Projeto</Form.Label>
            <Form.Control
              as="select"
              value={p.trava_projeto || 'N'}
              onChange={function (e) { handleChange('trava_projeto', e.target.value); }}
            >
              <option value="S">Sim</option>
              <option value="N">Não</option>
            </Form.Control>
          </Form.Group>
        </Col>
        <Col md={2}>
          <Form.Group>
            <Form.Label>Trava Carteira</Form.Label>
            <Form.Control
              type="text"
              maxLength={1}
              value={p.trava_carteira || ''}
              onChange={function (e) { handleChange('trava_carteira', e.target.value); }}
            />
          </Form.Group>
        </Col>
        <Col md={2}>
          <Form.Group>
            <Form.Label>Família Isenta Imp/Adm</Form.Label>
            <Form.Control
              type="number"
              value={p.codigo_familia_isenta || ''}
              onChange={function (e) { handleChange('codigo_familia_isenta', e.target.value); }}
            />
          </Form.Group>
        </Col>
        <Col md={2}>
          <Form.Group>
            <Form.Label>Imobiliária</Form.Label>
            <Form.Control
              type="text"
              maxLength={1}
              value={p.imobiliaria || ''}
              onChange={function (e) { handleChange('imobiliaria', e.target.value); }}
            />
          </Form.Group>
        </Col>
        <Col md={2}>
          <Form.Group>
            <Form.Label>Usuário Gerente</Form.Label>
            <Form.Control
              type="number"
              value={p.gerente || ''}
              onChange={function (e) { handleChange('gerente', e.target.value); }}
            />
          </Form.Group>
        </Col>
        <Col md={2}>
          <Form.Group>
            <Form.Label>Conta Desconto</Form.Label>
            <Form.Control
              type="number"
              value={p.conta_desconto_concedido || ''}
              onChange={function (e) { handleChange('conta_desconto_concedido', e.target.value); }}
            />
          </Form.Group>
        </Col>
      </Row>

      <fieldset className="mt-3 p-3" style={{ border: '1px solid #dee2e6', borderRadius: '6px' }}>
        <legend className="w-auto px-2" style={{ fontSize: '0.9rem', fontWeight: 600, color: '#495057' }}>
          Balanço
        </legend>
        <Row>
          <Col md={2}>
            <Form.Group>
              <Form.Label>Tipo CC</Form.Label>
              <Form.Control
                type="number"
                value={p.tipo_cc != null ? p.tipo_cc : ''}
                onChange={function (e) { handleChange('tipo_cc', e.target.value); }}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group>
              <Form.Label>Juros CC</Form.Label>
              <Form.Control
                type="number"
                step="0.0001"
                value={p.juros_cc != null ? p.juros_cc : ''}
                onChange={function (e) { handleChange('juros_cc', e.target.value); }}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group>
              <Form.Label>Corrige IPCA CC</Form.Label>
              <Form.Control
                as="select"
                value={p.corrige_igpm_cc || 'N'}
                onChange={function (e) { handleChange('corrige_igpm_cc', e.target.value); }}
              >
                <option value="S">Sim</option>
                <option value="N">Não</option>
              </Form.Control>
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group>
              <Form.Label>Tipo Juros</Form.Label>
              <Form.Control
                type="text"
                maxLength={1}
                value={p.tipo_juros || ''}
                onChange={function (e) { handleChange('tipo_juros', e.target.value); }}
              />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col md={2}>
            <Form.Group>
              <Form.Label>Taxa 1</Form.Label>
              <Form.Control
                type="number"
                step="0.0001"
                value={p.taxa1 != null ? p.taxa1 : ''}
                onChange={function (e) { handleChange('taxa1', e.target.value); }}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group>
              <Form.Label>Taxa 2</Form.Label>
              <Form.Control
                type="number"
                step="0.0001"
                value={p.taxa2 != null ? p.taxa2 : ''}
                onChange={function (e) { handleChange('taxa2', e.target.value); }}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group>
              <Form.Label>Taxa 10</Form.Label>
              <Form.Control
                type="number"
                step="0.0001"
                value={p.taxa10 != null ? p.taxa10 : ''}
                onChange={function (e) { handleChange('taxa10', e.target.value); }}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group>
              <Form.Label>Taxa 11</Form.Label>
              <Form.Control
                type="number"
                step="0.0001"
                value={p.taxa11 != null ? p.taxa11 : ''}
                onChange={function (e) { handleChange('taxa11', e.target.value); }}
              />
            </Form.Group>
          </Col>
        </Row>
      </fieldset>
    </div>
  );
};

export default TabGeral;
